import React, { useState } from 'react';

import { useContext } from 'react';
import { EnteredContext } from '../context/EnteredContext';

import 'animate.css';

import bckBtn from '../spritesheets/bckBtn.png';
import bckdivL from '../spritesheets/bckDivL.png';
import coretech from '../spritesheets/coretech.png';
import nutrition from '../spritesheets/nutrition.png';
import summary from '../spritesheets/summary.png';

import flora from '../proj-img/WhatTheFlora.png';
import iep from '../proj-img/iep.png';
import rexflection from '../proj-img/rexflection.png';

import woman from '../proj-img/woman.png';

export default function Info(props) {
  const { selected, setSelected } = useContext(EnteredContext);
  const [isHovered, setIsHovered] = useState(false);
  const info = {
    AB2: [
      'Software Developer Intern @ Topbox Marketing',
      `May 2024 - May 2025`,
      `At Topbox Marketing, I had the opportunity to tackle diverse challenges, from developing full-stack websites for global cosmetic brands and creating inhouse microservices to reduce internal operation costs. These microservices include a tool to audit user submissions with AI and an internal formbuilder to reduce costs by 50k.`,
      `Frontend: VueJS, NuxtJS, TailwindCSS, Typescript, Javascript`,
      `Backend: MySQL, HeidiSQL, DrizzleORM, Python`
    ],
    BC4: [
      'Software Engineering (BESc) @ Western University - GPA: 3.7',
      'Sept 2021 - April 2026',
      `Throughout my experience at Western University, I've developed a foundation in software engineering through relevant courses and hackathons.`,
      `Relevant Coursework: Scripting Programming Languages, Data Structures and Algorithms, Discrete Structures, Database Management Systems`,
      `Activities: UoftHacks Events Organizer, Game Design Society Events Director`
    ],
    DB3: [
      `WhatTheFlora Hackathon Project`,
      `SheHacks+ 8 Third Overall`,
      `WhatTheFlora is a mobile app which allows a user to take pictures of edible flora. Then, using image recognition, the application will identify the plant and log the identified plant in the FloraDex. The app is a fun outdoorsy twist on Pokemon.`,
      `Frontend: React-Native, Javascript, HTML/CSS`,
      `Backend: Python, Pytorch, Flask, NodeJS, MySQL`,
      flora,
      `https://devpost.com/software/whattheflora`
    ],
    AD1: [
      `In English Please`,
      `Western Hacks 10 Submission`,
      `In English Please is a web applications which translates complicated ingredients into plain English language. Simply take a photo of an ingredients list for any product, then upload it to the website. Complicated ingredients such as 'sucralose' and 'neotame' are translated to 'artificial sweetener'.`,
      `Frontend: ReactJS, Typescript, Javascript`,
      `Backend: NodeJS, ExpressJS, Google-cloud, Google-vision`,
      iep,
      `https://devpost.com/software/in-english-please`
    ],
    BA3: [
      `RexFlection`,
      `UoftHacks 11 Submission`,
      `Following the theme of nostalgia, we re-imagined the offline dinosaur game and re-discovered Google Photos from our childhood to create a fun memory gallery.`,
      `Frontend: ReactJS, Javascript`,
      `Backend: ExpressJS, NodeJS, Flask, Python, Google APIs`,
      rexflection,
      `https://devpost.com/software/rexflection`
    ],
    DC1: [
      `Technical Skills And Languages`,
      ``,
      `The various technological skills I've developed through my coursework, internships, and extracurriculars.`,
      `Programming Languages: Python, Java, Javascript, SQL, Typescript, HTML, CSS/Tailwind`,
      `Frameworks And Libraries: ReactJS, NodeJS, ExpressJS, NuxtJS, VueJS, DrizzleORM, React-Native`
    ],
    BD2: [
      `A little about me`,
      ``,
      `My name is Angela Deng, and I used to play a lot of flash games as a child, which is where my interest in programming started. I pursued this interest by taking multiple programming classes, which eventually led to my admission into the Software Engineering program at Western University. `,
      `In my free time, I explore my interest in video games through developing games using Unity and creating pixel art. Alongside this, I enjoy cooking, bouldering, and playing the ukelele.`,
      ``
    ],
    CB4: [
      `Pixel Art! ꒰ᐢ. .ᐢ꒱`,
      `Open for commissions!`,
      `I'm a pixel artist, drawing for fun and game development! I'm constantly learning new styles and techniques, and am looking forward to improving more.`,
      `I mainly use Aseprite for commissions & my main work, although I sometimes find myself using Pixaki or Procreate.`,
      ``,
      woman,
      ``
    ]
  };

  return (
    <div
      className={
        info[selected]
          ? `top-8 w-5/6 h-4/5 md:w-[444px] md:h-[644px] absolute flex flex-col justify-center items-center p-6 gap-6 z-50 ${props.animated} animate__bounceInLeft`
          : props.css
      }
      style={{
        backgroundImage: `url(${bckdivL})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}>
      <div
        className={`cursor-pointer ${props.animated} ${isHovered ? 'animate__headShake' : ''}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}>
        <img
          src={bckBtn}
          alt="Return"
          onClick={() => {
            setSelected('');
          }}
        />
      </div>
      {info[selected] ? (
        <div class="overflow-auto text-left flex px-6 flex-col gap-2 items-center">
          <img src={nutrition}></img>
          {info[selected][5] ? <img className="rounded-xl" src={info[selected][5]}></img> : ''}
          {info[selected][6] ? (
            <a href={info[selected][6]}>
              <u>
                <p>{info[selected][0]}</p>
              </u>
            </a>
          ) : (
            <p>{info[selected][0]}</p>
          )}
          <p>{info[selected][1]}</p>
          <img src={summary}></img>
          <p>{info[selected][2]}</p>
          <img src={coretech}></img>
          <p>{info[selected][3]}</p>
          <p>{info[selected][4]}</p>
        </div>
      ) : (
        ''
      )}
    </div>
  );
}
